// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.


/**************************************************** */
/*           GLOBAL CONFIGURATION PARAMETERS          */
/**************************************************** */

export const environment = {
  production: false
};

export const BOT_DATA_URL = 'https://devzurichchatbot.blob.core.windows.net/zurich-resources/bot_data.json';

export const evaConstants = {

  BOT_NAME: 'Johanna de Zurich Colombia',
  BACKGROUND: '#003399',
  IMAGE: {
    DEFAULT: 'https://devzurichchatbot.blob.core.windows.net/zurich-resources/avatar-default.png',
    AWAKE: '/assets/img/avatar-awake.jpg',
    SLEEP: 'https://devzurichchatbot.blob.core.windows.net/zurich-resources/avatar-sleeping.png',
    THANK_YOU: 'https://devzurichchatbot.blob.core.windows.net/zurich-resources/avatar-thank-you.png'
  },

  HEADERS: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'API-KEY': '228436ca-0017-4a34-af63-144b8d398e08',
    'PROJECT': 'PICHINCHA',
    'CHANNEL': 'HomeBanking',
    'OS': 'windows',
    'USER-REF': 'fguillee',
    'LOCALE': 'es-ES',
    'OS-VERSION': '10',
    'BROWSER': 'Chrome',
    'BROWSER-VERSION': '10'
  },

  CODES: {
    INIT_CODE: '%EVA_WELCOME_MSG',
    END_CODE: 'ZUR_END',
    FEEDBACK_CODE: 'ZUR_ENCUESTA',
    EVENT_END_CODE: 'ZUR_DESPEDIDA',
    DERIVE_CODE: 'ZUR_DERIVAR',
    NONE: 'NONE'
  },

  URL: 'https://api-pichincha.eva.bot/conversations'

};

export const LiveChatConstants = {
  apiUrl: 'wss://api.livechatinc.com/v3.1/customer/rtm/ws',
  licenseID: 11714424
};


export const timerConst = {
  SLEEP: 300000,
  END: 1500000,
};


/**************************************************** */
/*           BOTS LIST CONFIGURATION                  */
/**************************************************** */

export const botslist = {

  EvaPortalBeneficiosBR: {
    avatar: "https://storage.googleapis.com/eva-portalbeneficiosbr-images/avatar_03.png",
    before_you_go: "Antes que você vá embora",
    bot_name: "Eva",
    button_background: "#ff8300",
    button_color: "#ffffff",
    chat_input_hint: "Escreva sua respostas",
    client_name: "EvaPortalBeneficiosBR",
    code: "EvaPortalBeneficiosBR",
    favicon: "https://storage.googleapis.com/eva-portalbeneficiosbr-images/avatar_03.png",
    feedback_greeting: "Valeu por responder nosssa pesquisa!",
    feedback_message_01: "Para nós é muito importante saber a sua opinião",
    feedback_message_02: "Me conta, como foi sua experiência no nosso atendimento?",
    feedback_message_03: "Gostaria de deixar sua opinião ou um comentário? É só escrever abaixo",
    feedback_send_button: "Enviar",
    headers: {
      "API-KEY": "effae140-2268-462f-a1ba-9624c527e5ea",
      "Accept": "application/json",
      "BROWSER": "Chrome",
      "BROWSER-VERSION": "10",
      "BUSINESS-KEY": "123",
      "CHANNEL": "pb_br_web",
      "Content-Type": "application/json",
      "LOCALE": "pt-BR",
      "OS": "windows",
      "OS-VERSION": "10",
      "PROJECT": "EvaPortalBeneficiosBR",
      "USER-REF": "192.168.1.1"
    },
    logo: "",
    offline: "Offline",
    online: "Online",
    primary_color: "#ABB13C",
    secondary_color: "#F4F4FF",
    show_customer_form: false,
    text_button_color: "#ffffff",
    text_header_color: "#ffffff",
    text_primary_color: "",
    typing: "Digitando...",
    url: "https://api-everis.eva.bot/conversations",
    welcome_message: "Bem-vindo ao Portal de Benefícios!",
    write_your_opinion: "Escreva aqui sua opinião",
  }

};
